import { formatCurrencyAmount } from '@/lib/formatMoney';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export interface MrrRow {
  currency: string;
  mrr: number;
  arr: number;
  subscriptionCount: number;
}

export function RecurringRevenueTable({ rows }: { rows: MrrRow[] }) {
  if (rows.length === 0) {
    return <p className="py-8 text-center text-sm text-muted-foreground">No active paid subscriptions yet.</p>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Currency</TableHead>
          <TableHead>MRR</TableHead>
          <TableHead>ARR</TableHead>
          <TableHead>Subscriptions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.currency}>
            <TableCell className="font-medium">{row.currency}</TableCell>
            <TableCell>{formatCurrencyAmount(row.mrr, row.currency)}</TableCell>
            <TableCell>{formatCurrencyAmount(row.arr, row.currency)}</TableCell>
            <TableCell className="text-muted-foreground">{row.subscriptionCount}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
